import { Text, FormNumberInput } from '@shared/components';

import { QConfigSearchSelection } from '../qconfig-search-selection';

export default function GenerateQSetFormInputs() {
  return (
    <>
      <QConfigSearchSelection name='qConfig' />
      <FormNumberInput
        label='กำหนดค่าความซ้ำระหว่างชุด'
        name='duplicationRate'
        placeholder='0'
        min={0}
        max={100}
        sx={{
          maxWidth: '180px',
        }}
        slotProps={{
          input: {
            sx: (theme) => ({
              pr: theme.spacing(0),
            }),
            endAdornment: (
              <Text
                sx={(theme) => ({
                  position: 'absolute',
                  right: theme.spacing(3.5),
                  color: theme.palette.grey[500],
                })}
              >
                %
              </Text>
            ),
          },
          htmlInput: {
            sx: (theme) => ({
              p: theme.spacing(2.5, 3.5),
              minHeight: '44px',
              textAlign: 'left',
            }),
          },
        }}
      />
      <FormNumberInput
        label='จำนวนชุดข้อสอบ'
        name='needTotal'
        placeholder='ระบุจำนวนชุด'
        sx={{
          maxWidth: '180px',
          minHeight: '68px',
        }}
        slotProps={{
          input: {
            sx: (theme) => ({
              pr: theme.spacing(0),
            }),
          },
          htmlInput: {
            sx: (theme) => ({
              p: theme.spacing(2.5, 3.5),
              minHeight: '44px',
            }),
          },
        }}
      />
    </>
  );
}
